import { TrustPills } from "@/components/marketplace"
import type { FeedSection } from "@/features/feed/contract"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const BenefitsStripFeedSection = ({ section }: FeedSectionProps<Extract<FeedSection, { type: "BENEFITS_STRIP" }>>) => {
  const { title, items } = section.data
  if (!items?.length) return null
  return (
    <div className="px-gut">
      <TrustPills title={title} items={items} />
    </div>
  )
}
